import type { WithdrawalRequestFromBackend } from './types';

import { URL } from 'app/api/constants';

import type { ServiceConfig } from '../../../utils/create-http-api-service';
import { defaultRequestService } from '../../../utils/default-request-service';

export const getWithdrawalBalance = (config: ServiceConfig) => {
  type AdapterProps = { response: WithdrawalRequestFromBackend };
  const url = `${URL.WITHDRAWAL_ACTIVE}?readonly=true`;
  return defaultRequestService<AdapterProps>(url, config.instance.get);
};
